module.exports = __webpack_public_path__ + "static/media/icn_email_error.ab48ef7a.svg";